<!--
    描述：认证配置信息
    日期：2022/06/27
    作者：张卫华
-->
<template>
  <div class="tab-main-page">
    <div class="main-content">
      <el-row>
        <el-col :span="12">
          <span style="font-weight: bold">本次签署认证信息：</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            个人页面显示： 实名认证方式；个人银行卡四要素认证；个人运营商三要素认证；个人刷脸认证
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            企业页面显示实名认证方式： 组织机构对公账户打款认证；组织机构法定代表人授权书签署认证
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            指定意愿认证方式: 短信验证码；支付宝刷脸；腾讯云刷脸；e签宝刷脸
          </span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name : 'detail_tab_ici',
  components: {

  },
  data() {
    return {

    }
  },
  mounted() {},
  computed: {},
  // 进入缓存页面
  activated() {

  },
  watch: {},
  created() {},
  methods: {

  }
}
</script>
<style lang="less" scoped>
.tab-main-page {
  .main-content {
    font-family: 'Arial Normal', 'Arial';
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    color: #333333;
    line-height: normal;

    .el-row {
      padding : 10px 0px;
    }
  }
}
</style>